import RestrictionsSettingsModal from './RestrictionsSettingsModal'


export default RestrictionsSettingsModal
